import { getQueryParams } from '../selectors/router';
import {
  fetchWaveForecast,
  fetchTideForecast,
  fetchWeatherForecast,
  fetchWindForecast,
  fetchRegionalConditionForecast,
  fetchRegionalWaveForecast,
} from '../common/api/kbyg';
import { getActiveMeter } from '../selectors/meter';

const baseFetchGraphForecast =
  (action, success, failure, fetch) =>
  /**
   * @param {object} props
   * @param {string} props.id
   * @param {number} props.days
   * @param {number} props.intervalHours
   * @param {boolean} [props.maxHeights]
   * @param {number} [props.desired16DayInterval]
   * @param {boolean} [props.isGraphUpdates]
   */
  ({
    id,
    days,
    intervalHours,
    maxHeights = false,
    desired16DayInterval = intervalHours,
    isGraphUpdates = false,
  }) =>
  async (dispatch, getState) => {
    dispatch({ type: action });
    try {
      const state = getState();
      const meter = getActiveMeter(state);
      const { corrected, sharedTideService } = getQueryParams(state);

      const response = await fetch(
        id,
        days,
        intervalHours,
        maxHeights,
        corrected,
        sharedTideService,
        {
          meter,
        },
      );

      dispatch({
        type: success,
        intervalHours,
        desired16DayInterval,
        response,
        isGraphUpdates,
      });
    } catch (error) {
      dispatch({
        type: failure,
        error: error.message || 'something went wrong',
      });
    }
  };

export const FETCH_GRAPH_CONDITION_FORECAST = 'FETCH_GRAPH_CONDITION_FORECAST';
export const FETCH_GRAPH_CONDITION_FORECAST_SUCCESS = 'FETCH_GRAPH_CONDITION_FORECAST_SUCCESS';
export const FETCH_GRAPH_CONDITION_FORECAST_FAILURE = 'FETCH_GRAPH_CONDITION_FORECAST_FAILURE';

export const fetchGraphConditionForecast = baseFetchGraphForecast(
  FETCH_GRAPH_CONDITION_FORECAST,
  FETCH_GRAPH_CONDITION_FORECAST_SUCCESS,
  FETCH_GRAPH_CONDITION_FORECAST_FAILURE,
  fetchRegionalConditionForecast,
);

export const FETCH_GRAPH_WAVE_FORECAST = 'FETCH_GRAPH_WAVE_FORECAST';
export const FETCH_GRAPH_WAVE_FORECAST_SUCCESS = 'FETCH_GRAPH_WAVE_FORECAST_SUCCESS';
export const FETCH_GRAPH_WAVE_FORECAST_FAILURE = 'FETCH_GRAPH_WAVE_FORECAST_FAILURE';

export const fetchGraphWaveForecast = (type) =>
  baseFetchGraphForecast(
    FETCH_GRAPH_WAVE_FORECAST,
    FETCH_GRAPH_WAVE_FORECAST_SUCCESS,
    FETCH_GRAPH_WAVE_FORECAST_FAILURE,
    type === 'REGIONAL' ? fetchRegionalWaveForecast : fetchWaveForecast,
  );

export const FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS = 'FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS';
export const FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS_SUCCESS =
  'FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS_SUCCESS';
export const FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS_FAILURE =
  'FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS_FAILURE';

export const fetchGraphWaveForecastMaxHeights = (type) =>
  baseFetchGraphForecast(
    FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS,
    FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS_SUCCESS,
    FETCH_GRAPH_WAVE_FORECAST_MAX_HEIGHTS_FAILURE,
    type === 'REGIONAL' ? fetchRegionalWaveForecast : fetchWaveForecast,
  );

export const FETCH_GRAPH_TIDE_FORECAST = 'FETCH_GRAPH_TIDE_FORECAST';
export const FETCH_GRAPH_TIDE_FORECAST_SUCCESS = 'FETCH_GRAPH_TIDE_FORECAST_SUCCESS';
export const FETCH_GRAPH_TIDE_FORECAST_FAILURE = 'FETCH_GRAPH_TIDE_FORECAST_FAILURE';

export const fetchGraphTideForecast = baseFetchGraphForecast(
  FETCH_GRAPH_TIDE_FORECAST,
  FETCH_GRAPH_TIDE_FORECAST_SUCCESS,
  FETCH_GRAPH_TIDE_FORECAST_FAILURE,
  fetchTideForecast,
);

export const FETCH_GRAPH_WEATHER_FORECAST = 'FETCH_GRAPH_WEATHER_FORECAST';
export const FETCH_GRAPH_WEATHER_FORECAST_SUCCESS = 'FETCH_GRAPH_WEATHER_FORECAST_SUCCESS';
export const FETCH_GRAPH_WEATHER_FORECAST_FAILURE = 'FETCH_GRAPH_WEATHER_FORECAST_FAILURE';

export const fetchGraphWeatherForecast = baseFetchGraphForecast(
  FETCH_GRAPH_WEATHER_FORECAST,
  FETCH_GRAPH_WEATHER_FORECAST_SUCCESS,
  FETCH_GRAPH_WEATHER_FORECAST_FAILURE,
  fetchWeatherForecast,
);

export const FETCH_GRAPH_WIND_FORECAST = 'FETCH_GRAPH_WIND_FORECAST';
export const FETCH_GRAPH_WIND_FORECAST_SUCCESS = 'FETCH_GRAPH_WIND_FORECAST_SUCCESS';
export const FETCH_GRAPH_WIND_FORECAST_FAILURE = 'FETCH_GRAPH_WIND_FORECAST_FAILURE';

export const fetchGraphWindForecast = baseFetchGraphForecast(
  FETCH_GRAPH_WIND_FORECAST,
  FETCH_GRAPH_WIND_FORECAST_SUCCESS,
  FETCH_GRAPH_WIND_FORECAST_FAILURE,
  fetchWindForecast,
);
